<template>
    <modal size="lg" ref="modal" :scrollable="true" :has-footer="false" @hide="close()">
        <span slot="title">
            {{ integrated ? typeLabel : 'New ' + typeLabel }}
        </span>
        <ul class="nav nav-navs swell-modal-nav">
            <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" :href="'#' + uiType + '-details'" @click="activeTab = uiType + '-details'" role="tab">
                    Details
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" :href="'#' + uiType + '-integrations'" @click="activeTab = uiType + '-integrations'"  role="tab"
                    :class="{disabled: disabledTab}">
                    Integrations
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" :href="'#' + uiType + '-review-sites'" @click="activeTab = uiType + '-review-sites'" role="tab"
                    :class="{disabled: disabledTab}">
                    Manage Reviews
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" :href="'#' + uiType + '-write-review-sites'" @click="activeTab = uiType + '-write-review-sites'" role="tab"
                    :class="{disabled: disabledTab}">
                    Request Review Links
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" :href="'#' + uiType + '-period-invite'" @click="activeTab = uiType + '-period-invite'" role="tab"
                    :class="{disabled: disabledTab}">
                    Period
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <div class="tab-pane fade show active" :id="uiType + '-details'">
                <location-form-details
                    :ui-type="uiType"
                    :location="locationSelected"
                    @save-location="saveLocation"
                />
            </div>

            <div class="tab-pane fade" :id="uiType + '-integrations'">
                <location-form-integrations
                    :location="locationSelected"
                    @hide="hideLocationModal"
                    @show="open"
                    @save-location="saveLocation"
                />
            </div>

            <div class="tab-pane fade" :id="uiType + '-review-sites'">
                <location-form-manage-reviews
                    :location="locationSelected"
                    @save-location="saveLocation"
                />
            </div>
            <div class="tab-pane fade" :id="uiType + '-write-review-sites'">
                <location-form-request-reviews
                    :location="locationSelected"
                    @save-location="saveLocation"
                    @open="showModal()"
                    @hide="hideModal()"
                />
            </div>
            <div class="tab-pane fade" :id="uiType + '-period-invite'">
                <location-form-period
                    :location="locationSelected"
                    @save-location="saveLocation"
                />
            </div>
        </div>
    </modal>
</template>

<script>

    import _ from 'lodash';

    import LocationFormDetails        from './settings/LocationFormDetails';
    import LocationFormIntegrations   from './settings/LocationFormIntegrations';
    import LocationFormManageReviews  from './settings/LocationFormManageReviews';
    import LocationFormRequestReviews from './settings/LocationFormRequestReviews';
    import LocationFormPeriod         from './settings/LocationFormPeriod';

    export default {
        props: {
            locationSelected: { type: Object },
            uiType: { type: String, in: ['location', 'provider'] }
        },

        components: {
            LocationFormDetails,
            LocationFormIntegrations,
            LocationFormManageReviews,
            LocationFormRequestReviews,
            LocationFormPeriod,
        },

        data() {
            return {
                activeTab: this.uiType + '-details',
                openNewModal: false,
                // form: new Form(),
                // location: null,
                // campaigns: [],
            }
        },

        watch: {
            locationSelected: {
                handler() {
                    if (this.locationSelected) {
                        this.open();
                    }
                }
            },
        },

        computed: {
            integrated() {
                return !!this.locationSelected && !!this.locationSelected.id;
            },

            disabledTab() {
                return this.locationSelected && this.locationSelected.id ? false : true;
            },

            typeLabel() {
                return this.uiType === 'location' ? 'Location' : 'Provider';
            },
        },

        methods: {
            open() {
                this.openNewModal = false;
                this.$refs.modal.open();
                $(`[href='#${this.activeTab}']`).tab('show');
            },

            close() {
                this.$emit('hide-modal-form', this.openNewModal);
                if (!this.openNewModal) {
                    this.activeTab = this.uiType + '-details';
                }
            },

            hideLocationModal(value) {
                this.openNewModal = value;
                this.$refs.modal.close();
            },

            saveLocation(locationId) {
                this.$emit('changed', locationId);
            },

            hideModal() {
                this.$refs.modal.close();
            },

            showModal() {
                this.$refs.modal.open();
            }
        }
    }
</script>
